module.exports = __webpack_public_path__ + "static/media/LogoRed.f493eca2.png";